class ModuleHelper {
  constructor() {
    this.addEventListener();
  }
  addEventListener() {
    $('textarea').on('keydown', function (e) {
      // ตรวจจับเมื่อกด Enter (keyCode 13)
      if (e.keyCode === 13 || e.which === 13) {
        var textarea = $(this);
        var content = textarea.val();
        var cursorPos = textarea[0].selectionStart;

        // หาบรรทัดปัจจุบัน
        var textBeforeCursor = content.substring(0, cursorPos);
        var currentLineStart = textBeforeCursor.lastIndexOf('\n') + 1;
        var currentLine = textBeforeCursor.substring(currentLineStart);

        // ตรวจสอบว่าบรรทัดปัจจุบันตรงกับรูปแบบ "ตัวเลข. "
        var match = currentLine.match(/^(\d+)\.\s/);

        if (match) {
          e.preventDefault(); // ป้องกันการขึ้นบรรทัดใหม่ปกติ

          var currentNum = parseInt(match[1]);
          var nextNum = currentNum + 1;
          var newLine = '\n' + nextNum + '. ';

          // แทรกบรรทัดใหม่พร้อมหมายเลขถัดไป
          var newContent = content.substring(0, cursorPos) + newLine + content.substring(cursorPos);
          textarea.val(newContent);

          // ย้าย cursor ไปท้ายหมายเลขที่เพิ่งแทรก
          var newCursorPos = cursorPos + newLine.length;
          textarea[0].setSelectionRange(newCursorPos, newCursorPos);
        }
      }
    });
  }
  /**
   * แปลงรูปแบบวันที่เป็นรูปแบบไทย (พ.ศ.)
   * @param {string} date - วันที่ในรูปแบบ YYYY-MM-DD HH:MM:SS
   * @returns {string} - วันที่ในรูปแบบ D เดือน YYYY โดยปีเป็น พ.ศ.
   * @author เต้ย
   */
  /**
   * แปลงรูปแบบวันที่เป็นรูปแบบไทย (พ.ศ.) และกำหนด timezone เป็นไทย (GMT+7)
   * @param {string} date - วันที่ในรูปแบบ YYYY-MM-DD HH:MM:SS
   * @param {string} format - เลือก "datetime" หรือ "date"
   * @returns {string} - วันที่ในรูปแบบ D เดือน YYYY โดยปีเป็น พ.ศ.
   * @author เต้ย
   */
  thDate(date, format = 'datetime') {
    if (!date) return '';

    // ฟังก์ชันนี้รับวันที่รูปแบบ 'YYYY-MM-DD HH:mm:ss' (เช่น '2025-10-20 21:54:48')
    // ต้องการให้แสดงตามเวลาไทย UTC+7 ที่ถูกต้องแบบ manual ไม่ให้ JS แปลงอัตโนมัติ (ป้องกัน timezone shift)
    try {
      let dateObj = null;

      // ตรวจสอบรูปแบบ string
      if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}( \d{2}:\d{2}:\d{2})?$/.test(date)) {
        // ดึงปี เดือน วัน และ (ถ้ามี) เวลา
        let parts = date.split(' ');
        let dateParts = parts[0].split('-');
        let timeParts = parts[1] ? parts[1].split(':') : ['00', '00', '00'];

        // กำหนดค่าปี เดือน วัน ชั่วโมง นาที วินาที เป็น number (ไม่มีการแปลง timezone ใดๆ)
        let year = parseInt(dateParts[0], 10);
        let month = parseInt(dateParts[1], 10) - 1; // JS: 0=Jan
        let day = parseInt(dateParts[2], 10);
        let hour = parseInt(timeParts[0], 10);
        let minute = parseInt(timeParts[1], 10);
        let second = parseInt(timeParts[2], 10);

        // สร้าง Date ที่ 'Asia/Bangkok' (บังคับเวลาไทย) ด้วย day/month/year/h/m/s ตรงไปตรงมา
        // (ใช้ Date(year, month-1, day, h, m, s) ซึ่งไม่แปลงตาม timezone string เฉพาะ browser นี้)
        // เช่น 2025-10-20 21:54:48 ในไทย จะตรงกับเวลาเดียวกัน
        dateObj = new Date(year, month, day, hour, minute, second);
      } else {
        // fallback สำหรับรูปแบบอื่น
        dateObj = new Date(date);
      }

      if (isNaN(dateObj.getTime())) return date;

      // รูปแบบเดือนแบบไทย
      const thaiMonths = [
        'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
        'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
      ];

      const dayNum = dateObj.getDate();
      const monthIndex = dateObj.getMonth();
      const yearCE = dateObj.getFullYear();
      const yearBE = yearCE + 543;
      const hours = String(dateObj.getHours()).padStart(2, '0');
      const minutes = String(dateObj.getMinutes()).padStart(2, '0');

      if (format === 'datetime') {
        return `${dayNum} ${thaiMonths[monthIndex]} ${yearBE} ${hours}:${minutes}`;
      } else if (format === 'date') {
        return `${dayNum} ${thaiMonths[monthIndex]} ${yearBE}`;
      } else {
        return `${dayNum} ${thaiMonths[monthIndex]} ${yearBE} ${hours}:${minutes}`;
      }
    } catch (error) {
      console.error('เกิดข้อผิดพลาดในการแปลงวันที่:', error);
      return date;
    }
  }
  /**
   * แปลงรูปแบบวันที่เป็นรูปแบบไทย (พ.ศ.)
   * @param {object} object - วันที่ในรูปแบบ YYYY-MM-DD HH:MM:SS
   * @returns {string} - วันที่ในรูปแบบ D เดือน YYYY โดยปีเป็น พ.ศ.
   * @author เต้ย
   */
  objectToHtml(object) {
    let html = '';
    for (let key in object) {
      if (typeof object[key] === 'object') {
        html += `<p><strong>${key}</strong>: ${this.objectToHtml(object[key])}</p>`;
      } else {
        // ตรวจสอบว่าเป็นรูปแบบวันที่หรือไม่
        const dateTimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/; // รูปแบบ Y-m-d H:i:s
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // รูปแบบ Y-m-d

        if (typeof object[key] === 'string' && (dateTimeRegex.test(object[key]) || dateRegex.test(object[key]))) {
          const format = dateTimeRegex.test(object[key]) ? 'datetime' : 'date';
          html += `<p><strong>${key}</strong>: ${this.thDate(object[key], format)}</p>`;
        } else {
          html += `<p><strong>${key}</strong>: ${object[key]}</p>`;
        }
      }
    }
    return html;
  }
  /**
   * @author เต้ย
   * @description สร้าง option สำหรับ select2
   * @param {array} data - ข้อมูล
   * @param {object} options - ตัวเลือก
   * @param {string} options.value - ค่า value
   * @param {string} options.text - ค่า text
   * @param {object} options.data - ข้อมูลสำหรับส่งไปยังตัวเลือก
   * @returns {string} - html
   */
  generateOptionSelect2(data, element, options) {
    let html = '';
    if (data.length > 0) {
      html += `<option value="" selected></option>`;
      data.forEach(item => {
        let dataAttribute = '';

        if (options.data) {
          Object.keys(options.data).forEach(key => {
            if (options.data[key].fromData) {
              dataAttribute += `data-${key}="${item[options.data[key].value]}" `;
            } else {
              dataAttribute += `data-${key}="${options.data[key]}" `;
            }
          });
        }

        html += `<option value="${item[options.value]}" ${dataAttribute}>${item[options.text]}</option>`;
      });
    }
    $(element).html(html).select2();
  }
  /**
   * @author เต้ย
   * @description แสดง sweetalert
   * @param {object} options - ตัวเลือก
   * @param {string} options.title - หัวข้อ
   * @param {string} options.text - ข้อความ
   * @param {string} options.icon - รูปแบบ icon (success, error, warning, info, question)
   * @param {string} options.confirmButtonText - ข้อความปุ่มยืนยัน
   * @param {string} options.cancelButtonText - ข้อความปุ่มยกเลิก
   * @param {boolean} options.showCancelButton - แสดงปุ่มยกเลิก
   * @param {string} options.confirmButtonColor - สีปุ่มยืนยัน
   * @param {string} options.cancelButtonColor - สีปุ่มยกเลิก
   * @param {boolean} options.reverseButtons - กลับปุ่มยกเลิกและยืนยัน
   * @param {string} options.html - ข้อความแบบ HTML
   * @param {boolean} options.allowOutsideClick - อนุญาตให้คลิกด้านนอกปิด modal
   * @param {boolean} options.allowEscapeKey - อนุญาตให้กด ESC ปิด modal
   * @param {string} options.width - ความกว้างของ modal
   * @param {string} options.padding - ระยะห่างขอบของ modal
   * @returns {Promise<object>} - ผลลัพธ์การแสดง sweetalert
   */
  async sweetalert(options = {}) {
    const defaultOptions = {
      title: 'แจ้งเตือน',
      text: '',
      icon: 'info',
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      reverseButtons: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      width: 'auto',
      padding: '1.25rem',
    };

    // Merge default options with provided options
    const swalOptions = { ...defaultOptions, ...options };

    try {
      const result = await Swal.fire(swalOptions);
      return result;
    } catch (error) {
      console.error('Sweetalert error:', error);
      throw error;
    }
  }
  /**
   * @author เต้ย
   * @description ฟังก์ชัน format ตัวเลขแบบ number_format ของ PHP
   * @param {number} number - ตัวเลขที่ต้องการ format
   * @param {number} decimals - จำนวนทศนิยม
   * @param {string} dec_point - ตัวคั่นทศนิยม
   * @param {string} thousands_sep - ตัวคั่นหลักพัน
   * @returns {string}
   * @example numberFormat(1000, 2) => "1,000.00"
   */
  numberFormat(number, decimals = 2, dec_point = '.', thousands_sep = ',') {
    // ถ้าไม่ใช่ตัวเลขหรือเป็น null/undefined ให้คืนค่า 0.00
    if (number === null || number === undefined || isNaN(number)) {
      number = 0;
    }
    // แปลงเป็น float
    number = parseFloat(number);

    // ปัดเศษทศนิยม
    const fixedNumber = number.toFixed(decimals);

    // แยกส่วนจำนวนเต็มกับทศนิยม
    let [integerPart, decimalPart] = fixedNumber.split('.');

    // ใส่คั่นหลักพัน
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands_sep);

    // คืนค่ารูปแบบที่ต้องการ
    return decimals > 0 ? `${integerPart}${dec_point}${decimalPart}` : integerPart;
  }

  /**
   * @author เต้ย
   * @description ที่มาของแอปจาก user-agent — ใช้บอกใบ้ว่าแอปที่ชื่อซ้ำกันมาจากไหน
   *
   *  เบราว์เซอร์บอกระบบปฏิบัติการมา · ตัวเชื่อมที่วิ่งจากเซิร์ฟเวอร์ไม่ใช่เบราว์เซอร์
   *  แต่บอกชื่อโปรแกรมมาตรง ๆ (เช่น python-httpx/0.28.1 ของตัวเชื่อมฝั่ง Claude)
   *  คืนชื่อโปรแกรมนั้นดีกว่าคืนค่าว่างแล้วให้หน้าจอเขียนว่าไม่ทราบ ทั้งที่รู้อยู่ว่ามาจากอะไร
   *
   *  จับไม่ได้จริง ๆ ถึงคืนค่าว่าง ให้หน้าจอตัดสินเองว่าจะเขียนว่าไม่ทราบอย่างไร
   * @param {string|null} userAgent
   * @returns {string} macOS | Windows | Linux | iOS | Android | ชื่อโปรแกรม | ''
   */
  deviceHint(userAgent) {
    const ua = String(userAgent || '').trim();
    if (!ua) return '';
    // Android ประกาศตัวว่าเป็น Linux ด้วย ต้องเช็คก่อน · iPad รุ่นใหม่ประกาศว่าเป็น Mac ต้องเช็ค iPhone/iPad ก่อน Mac
    if (/Android/i.test(ua)) return 'Android';
    if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
    if (/Mac OS X|Macintosh/i.test(ua)) return 'macOS';
    if (/Windows/i.test(ua)) return 'Windows';
    if (/Linux|X11/i.test(ua)) return 'Linux';
    // ไม่ประกาศตัวเป็นเบราว์เซอร์ = โปรแกรมที่เรียกตรง ชื่อคำแรกคือชื่อโปรแกรมกับรุ่น
    if (!/^Mozilla\//i.test(ua)) return ua.split(/\s+/)[0].slice(0, 40);
    return '';
  }
  /**
   * @author เต้ย
   * @description ip แบบย่อ — ซ่อนกลุ่มท้ายให้พอเทียบได้ว่ามาจากเครือข่ายเดียวกันไหม โดยไม่โชว์เลขเต็ม
   * @param {string|null} ip
   * @returns {string} เช่น 203.0.113.x หรือ 2001:db8:85a3:… · ไม่รู้คืนค่าว่าง
   */
  shortIp(ip) {
    const raw = String(ip || '').trim().replace(/^::ffff:/i, '');
    if (!raw || raw.toLowerCase() === 'unknown') return '';
    const v4 = raw.match(/^(\d{1,3}\.\d{1,3}\.\d{1,3})\.\d{1,3}$/);
    if (v4) return `${v4[1]}.x`;
    if (raw.includes(':')) return `${raw.split(':').slice(0, 3).join(':')}:…`;
    return raw;
  }
  /**
   * @author เต้ย
   * @description error นี้ axios_interceptor.js แสดง toast ไปแล้วหรือยัง (401/403/404/422/5xx และต่อไม่ติด)
   * ใช้ใน catch ของหน้า เพื่อ toast เฉพาะกรณีที่ interceptor ไม่ได้แสดง จะได้ไม่ขึ้นซ้อนสองอัน
   * @param {object} error - Error object จาก axios
   * @returns {boolean}
   */
  isToastedByInterceptor(error) {
    if (!error || !error.isAxiosError) return false;
    if (!error.response) return true;
    const status = error.response.status;
    return status === 401 || status === 403 || status === 404 || status === 422 || status >= 500;
  }
  /**
   * @author เต้ย
   * @description Escape HTML characters
   * @param {string} text - ข้อความที่ต้องการ escape
   * @returns {string} escaped text
   */
  escapeHtml(text) {
    if (!text) return '';
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.toString().replace(/[&<>"']/g, (m) => map[m]);
  }
  /**
   * @author เต้ย
   * @description คำนวณสีตัวอักษรที่เหมาะสมกับพื้นหลัง
   * @param {string} hexColor - สีพื้นหลังในรูปแบบ hex
   */
  getContrastColor(hexColor) {
    // แปลง hex เป็น RGB
    // ตรวจสอบว่า hexColor มีค่าและอยู่ในรูปแบบที่ถูกต้องหรือไม่
    if (!hexColor || typeof hexColor !== 'string' || !/^#([A-Fa-f0-9]{6})$/.test(hexColor)) {
      // ถ้าไม่ถูกต้อง ให้ใช้สีดำเป็นค่า default
      return 0; // จะถูกใช้ใน brightness ด้านล่าง
    }
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);

    // คำนวณความสว่าง
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // ถ้าสีเข้มใช้ตัวอักษรสีขาว ถ้าสีอ่อนใช้ตัวอักษรสีดำ
    return brightness > 125 ? '#000000' : '#ffffff';
  }
  /**
   * @author เต้ย
   * @description คำนวณเวลาที่ผ่านมา
   * @param {string} dateString - วันที่ในรูปแบบ string
   */
  getTimeAgo(dateString) {
    // แปลง dateString format "YYYY-MM-DD HH:mm:ss" ให้ใช้กับ JavaScript Date ได้
    try {
      // แทนที่ space ด้วย 'T' เพื่อให้ new Date() รองรับ
      const isoString = dateString.replace(' ', 'T');
      const date = new Date(isoString);
      const now = new Date();
      const diffInSeconds = Math.floor((now - date) / 1000);

      if (isNaN(date.getTime())) {
        // ถ้าแปลงวันที่ไม่ได้ ให้คืนค่าค่าว่าง
        return "";
      }

      if (diffInSeconds < 60) {
        return "เมื่อสักครู่";
      } else if (diffInSeconds < 3600) {
        const minutes = Math.floor(diffInSeconds / 60);
        return `${minutes} นาทีที่แล้ว`;
      } else if (diffInSeconds < 86400) {
        const hours = Math.floor(diffInSeconds / 3600);
        return `${hours} ชั่วโมงที่แล้ว`;
      } else if (diffInSeconds < 2592000) {
        const days = Math.floor(diffInSeconds / 86400);
        return `${days} วันที่แล้ว`;
      } else {
        const months = Math.floor(diffInSeconds / 2592000);
        return `${months} เดือนที่แล้ว`;
      }
    } catch (error) {
      // คืนค่าค่าว่างถ้าเกิดข้อผิดพลาด
      return "";
    }
  }
}